import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import VueClipboard from 'vue-clipboard2';
import router from './router';
import store from './store';
import { request } from './assets/fetchHandler';
import { enjory } from './assets/enjory';
import { getCookie, setCookie } from './assets/login';
import { Loading, Dialog, Toast, Swipe, SwipeItem, Popup, Area, Button, DropdownMenu, DropdownItem, List, Field } from 'vant';
import VueLazyload from 'vue-lazyload';

//  reset CSS
import 'normalize.css/normalize.css';
import './style/box.css';
import './style/reset.scss';

Vue.config.productionTip = false; // 设置为 false 以阻止 vue 在启动时生成生产提示。
Vue.prototype.request = request;
Vue.prototype.axios = axios;
Vue.prototype.enjory = enjory;
Vue.prototype.$cookieStore = {
  setCookie,
  getCookie
};
Vue.config.silent = true; // 取消 Vue 所有的日志与警告。
Vue
  .use(VueLazyload)
  .use(VueClipboard)
  .use(Loading)
  .use(Dialog)
  .use(Toast)
  .use(Swipe)
  .use(SwipeItem)
  .use(Area)
  .use(Popup)
  .use(Button)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(List)
  .use(Field)
window.addEventListener('pageshow', (e) => {
  console.log(router.history.current.name)
  if (router.history.current.name !== "home") {
    enjory()
  }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
